var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16602 4.16667C3.945 4.16667 3.73304 4.25446 3.57676 4.41074C3.51577 4.47173 3.46521 4.5412 3.42623 4.61638L9.99935 8.99846L16.5725 4.61638C16.5335 4.5412 16.4829 4.47173 16.4219 4.41074C16.2657 4.25446 16.0537 4.16667 15.8327 4.16667H4.16602ZM16.666 6.5571V11.25C16.666 11.7102 17.0391 12.0833 17.4993 12.0833C17.9596 12.0833 18.3327 11.7102 18.3327 11.25V5C18.3327 4.33696 18.0693 3.70107 17.6005 3.23223C17.1316 2.76339 16.4957 2.5 15.8327 2.5H4.16602C3.50297 2.5 2.86709 2.76339 2.39825 3.23223C1.92941 3.70107 1.66602 4.33696 1.66602 5V13.3333C1.66602 13.9964 1.92941 14.6323 2.39825 15.1011C2.86709 15.5699 3.50297 15.8333 4.16602 15.8333H9.99935C10.4596 15.8333 10.8327 15.4602 10.8327 15C10.8327 14.5398 10.4596 14.1667 9.99935 14.1667H4.16602C3.945 14.1667 3.73304 14.0789 3.57676 13.9226C3.42048 13.7663 3.33268 13.5543 3.33268 13.3333V6.5571L9.5371 10.6934C9.81702 10.88 10.1817 10.88 10.4616 10.6934L16.666 6.5571ZM14.4101 11.9107C14.7355 11.5853 15.2632 11.5853 15.5886 11.9107L18.0886 14.4107C18.414 14.7362 18.414 15.2638 18.0886 15.5893L15.5886 18.0893C15.2632 18.4147 14.7355 18.4147 14.4101 18.0893C14.0847 17.7638 14.0847 17.2362 14.4101 16.9107L15.4875 15.8333H12.4993C12.0391 15.8333 11.666 15.4602 11.666 15C11.666 14.5398 12.0391 14.1667 12.4993 14.1667H15.4875L14.4101 13.0893C14.0847 12.7638 14.0847 12.2362 14.4101 11.9107Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.cd9c86aef036b7d1239be1540d9c091e.svg";
export { ForwardRef as ReactComponent };